import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonReload: { defaultMessage: 'Reload' },
  buttonBack: { defaultMessage: 'Back' },
});
